// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"2b08ba5a","659":"3b6434ba"}[chunkId] + ".chunk.js";
};